export default __webpack_public_path__ + "static/media/aiorchestration.45b04dd4.png";